import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Calculation, GetFeedProfitCalculationsResponse } from '../models/feed-profit.model';

@Injectable({
  providedIn: 'root',
})
export class FeedProfitService {
  protected baseUrl = `${this.env.API_BASE_URL}/service/pig-registration/secure/feedprofit`;

  constructor(
    protected http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: { API_BASE_URL: string },
  ) {}

  getCalculationById(calculationId: number): Observable<Calculation | HttpErrorResponse> {
    return this.http.get<Calculation>(`${this.baseUrl}/${calculationId}`, {}).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Calculation>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  getCalculations(): Observable<Calculation[] | HttpErrorResponse> {
    return this.http.get<GetFeedProfitCalculationsResponse>(this.baseUrl, {}).pipe(
      map((response) => response.calculations),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Calculation[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  upsertCalculation(calculation: Calculation): Observable<number | HttpErrorResponse> {
    return this.http.post<number>(this.baseUrl, calculation).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<number>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  deleteCalculation(calculationId: number) {
    return this.http.delete(`${this.baseUrl}/${calculationId}`);
  }
}
